var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.561 16c-.242 0-.477-.084-.665-.24l-6.233-5.043a.681.681 0 0 1-.094-.925.635.635 0 0 1 .894-.125l6.098 4.936 9.166-7.671a.635.635 0 0 1 .912.097.68.68 0 0 1-.096.938l-9.299 7.78a1.052 1.052 0 0 1-.683.253Zm-8.06-6.414a.646.646 0 0 1-.402-.142L.289 7.972a.682.682 0 0 1-.15-.968.635.635 0 0 1 .949-.078l1.815 1.468c.28.23.329.65.109.94a.653.653 0 0 1-.51.252Zm8.29-.369c-.243 0-.477-.084-.667-.24L3.875 3.943a.68.68 0 0 1-.095-.925.635.635 0 0 1 .895-.125l6.115 4.928L19.943.149a.637.637 0 0 1 .912.097.681.681 0 0 1-.095.94l-9.3 7.778c-.19.16-.425.25-.67.253ZM2.716 2.804a.659.659 0 0 1-.402-.142L.505 1.19a.68.68 0 0 1-.07-.903.636.636 0 0 1 .87-.142L3.12 1.612h-.001c.28.23.329.648.108.938a.658.658 0 0 1-.51.254Z",
  fill: "currentcolor"
})));

export default SvgIconMore;